import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getCustomerSingleOrder = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId,
    headers: getHeaders(),
  });
};

export const getCustomerSingleOrderInfo = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId + "/info",
    headers: getHeaders(),
  });
};

export const getOrderDocs = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId + "/order-docs",
    headers: getHeaders(),
  });
};

export const getStoreUserFullInfo = (id) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + "/store/api/secure/v1/store-user/" + id,
    headers: getHeaders(),
  });
};

export const getCustomerSingleOrderGarmentServiceInfo = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId + "/garment-service-info",
    headers: getHeaders(),
  });
};

export const getCustomerSingleOrderPackage = (
  id,
  storeId,
  orderId,
  priceListId,
) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/package/' +
      priceListId,
    headers: getHeaders(),
  });
};

export const getOrderItemQrCodeMap = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/item-qrcode',
    headers: getHeaders(),
  });
};

export const postOrderItemQrCodeMap = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/item-qrcode',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const orderInfoBasedOnQrCode = (id) => {
  return axios({
    method: "get",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/qr-code/" +
      id +
      "/order-info",
    headers: getHeaders(),
  });
};

export const removeGarment = (storeId, storeCustomerId, orderId, orderItemId) => {
  return axios({
    method: "DELETE",
    url:
      STORE_BASE_URL + 
      "/store/api/secure/v1/store/" + storeId + "/store-customer/" + storeCustomerId + "/order/" + orderId + "/order-item/" + orderItemId,
    headers: getHeaders(),
  });
};

// B2B modal

export const getCustomerSingleB2BOrderInfo = (id, storeId, challanId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/challan/' +
      challanId,
    headers: getHeaders(),
  });
};

export const removeGarmentB2B = (storeId, storeCustomerId, challanId, orderItemId) => {
  return axios({
    method: "DELETE",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/b2b/store/" + storeId + "/store-customer/" + storeCustomerId + "/challan/" + challanId + "/challan-item/" + orderItemId,
    headers: getHeaders(),
  });
};

export const getCustomerSingleOrderReOpen = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId + "/re-open",
    headers: getHeaders(),
  });
};